import { getFunctions, httpsCallable } from "firebase/functions";
import { getServicePublicInfoClient, getServicesByCategoryClient, getServiceWithItemsClient, addServiceOfferingClient, addServiceCategoryClient, addCategoryItemsClient, getServiceBySlugClient, getServiceItemDetailsClient } from "./client/serviceServiceClient";
import { getUserDataClient, getUserBookingsClient, cancelUserBookingClient, getProviderAndServiceDataClient, updateUserProfileFieldClient, getUserFavoritesClient, checkUserExistsClient } from "./client/userServiceClient";
import { app } from "../services/firebase";
import { disableServiceClient, disableServiceItemClient, enableServiceClient, enableServiceItemClient, getProviderPublicInfoClient, sendEditRequestClient, subscribeToEditRequestsClient, cancelEditRequestClient, updateServiceOpenStatusClient, getServiceItemClient, getServiceItemsClient, getServiceItemsPreviewClient, updateContactMethodsClient, getServiceOrderPlatformsClient, updateAvailabilityClient, checkProviderExistsClient, createProviderClient, createServiceClient, getProviderAvailabilityClient, updateServiceBookingPrefsClient, updateServiceItemClient, updateServiceOrderPlatformsClient } from "./client/providerServiceClient";
import { submitBookingFeedback, getProviderBookingsClient, updateBookingStatusClient, getServiceBookingsClient, createBookingClient, getUserConsultationStatusClient } from "./client/bookingServiceClient";
import { addEstablishmentClient, saveServiceDetailsClient } from "./client/adminServiceClient";
import { geocodeAddressClient } from "./client/geocodingServiceClient";
import { getServiceAnalyticsClient } from "./client/analyticsServiceClient";
import { submitContactMessageClient } from "./client/contactServiceClient";

const functions = getFunctions(app);

function callable(name) {
  return (data = {}) => httpsCallable(functions, name)(data).then(res => res.data);
}

export const Backend = {
  serviceService: {
    getFoodServices: (data) => getServicesByCategoryClient({...data, category: 'food'}),
    getHairServices: (data) => getServicesByCategoryClient({...data, category: 'hair'}),
    getLocalBusinesses: (data) => getServicesByCategoryClient({...data, category: 'local'}),
    getOtherServices: (data) => getServicesByCategoryClient({...data, category: 'other'}),
    getServiceWithItems: (data) => getServiceWithItemsClient(data),
    getServicePublicInfo: (data) => getServicePublicInfoClient(data),
    addServiceOffering: (data) => addServiceOfferingClient({...data}),
    addServiceCategory: (data) => addServiceCategoryClient({...data}),
    addCategoryItems: (data) => addCategoryItemsClient({...data}),
    getServiceBySlug: (data) => getServiceBySlugClient(data),
    getServiceItemDetails: (data) => getServiceItemDetailsClient(data)
  },
  userService: {
    getUserData: (uid) => getUserDataClient(uid),
    checkProviderStatus: callable("checkProviderStatus"),
    getUserRoles: callable("getUserRoles"),
    getFavoriteServices: callable("getFavoriteServices"),
    getUserBookings: (data) => getUserBookingsClient({...data}),
    cancelUserBooking: (data) => cancelUserBookingClient({...data}),
    getProviderAndServiceData: (data) => getProviderAndServiceDataClient({...data}),
    updateUserProfileField: (data) => updateUserProfileFieldClient({...data}),
    getUserFavorites: (data) => getUserFavoritesClient(data),
    checkUserExists: (data) => checkUserExistsClient(data)
  },
  searchService: {
    searchServices: callable("searchServices"),
    getSearchSuggestions: callable("getSearchSuggestions"),
  },
  reviewService: {
    submitServiceReview: callable("submitServiceReview"),
    toggleFavoriteService: callable("toggleFavoriteService"),
  },
  providerService: {
    getProviderPublicInfo : (data) => getProviderPublicInfoClient(data),
    getProviderDashboardData: callable("getProviderDashboardData"),
    registerServiceProvider: callable("registerServiceProvider"),
    toggleServilliaDiscount: callable("toggleServilliaDiscount"),
    updateServiceLayout: callable("updateServiceLayout"),
    updateServiceImages: callable("updateServiceImages"),
    submitModificationRequest: callable("submitModificationRequest"),
    disableService : (data) => disableServiceClient({...data}),
    enableService : (data) => enableServiceClient({...data}),
    disableServiceItem : (data) => disableServiceItemClient({...data}),
    enableServiceItem : (data) => enableServiceItemClient({...data}),
    sendEditRequest : (data) => sendEditRequestClient({...data}),
    subscribeToEditRequests : (data) => subscribeToEditRequestsClient({...data}),
    cancelEditRequest : (data) => cancelEditRequestClient({...data}),
    updateServiceOpenStatus : (data) => updateServiceOpenStatusClient({...data}),
    updateServiceBookingPrefs : (data) => updateServiceBookingPrefsClient({...data}),
    updateServiceItem : (data) => updateServiceItemClient({...data}),
    updateServiceOrderPlatforms : (data) => updateServiceOrderPlatformsClient({...data}),
    getServiceItem : (data) => getServiceItemClient({...data}),
    getServiceItems : (data) => getServiceItemsClient({...data}),
    getServiceItemsPreview : (data) => getServiceItemsPreviewClient({...data}),
    updateContactMethods : (data) => updateContactMethodsClient({...data}),
    getServiceOrderPlatforms : (data) => getServiceOrderPlatformsClient({...data}),
    updateAvailability : (data) => updateAvailabilityClient({...data}),
    checkProviderExists: (data) => checkProviderExistsClient(data),
    createProvider: (data) => createProviderClient(data),
    createService: (data) => createServiceClient(data),
    getProviderAvailability: (data) => getProviderAvailabilityClient(data)
  },
  geocodingService: {
    geocodeAddress: (data) => geocodeAddressClient(data)
  },
  adminService: {
    getAdminRequests: callable("getAdminRequests"),
    approveService: callable("approveService"),
    approveModification: callable("approveModification"),
    rejectModificationRequest: callable("rejectModificationRequest"),
    processImageEditRequest: callable("processImageEditRequest"),
    addEstablishment: (data) => addEstablishmentClient(data),
    saveServiceDetails: (data) => saveServiceDetailsClient(data)
  },
  analyticsService: {
    logServiceClick: callable("logServiceClick"),
    getServiceAnalytics: (data) => getServiceAnalyticsClient(data)
  },
  emailService: {
    sendWelcomeEmail: callable("sendWelcomeEmail"),
    sendBookingConfirmationEmails: callable("sendBookingConfirmationEmails"),
    sendBookingAcceptedEmail: callable("sendBookingAcceptedEmail"),
    sendBookingRejectedEmail: callable("sendBookingRejectedEmail"),
    sendBookingCancelledEmail: callable("sendBookingCancelledEmail"),
  },
  bookingService : {
    submitBookingFeedback : (data) => submitBookingFeedback({...data}),
    getProviderBookings : (data) => getProviderBookingsClient({...data}),
    updateBookingStatus : (data) => updateBookingStatusClient({...data}),
    getServiceBookings: (data) => getServiceBookingsClient(data),
    createBooking: (data) => createBookingClient(data),
    getUserConsultationStatus: (data) => getUserConsultationStatusClient(data)
  },
  contactService : {
    submitContactMessage: (data) => submitContactMessageClient({...data})
  },
  paymentService: {
    createDepositCheckout: callable("createDepositCheckout"),
    verifyAndCreateBooking: callable("verifyAndCreateBooking")
  }
};
